/**
 * 첫 방문 대본 (DEV_SPEC 4.1, 프로토타입 App.dc.html 의 카운터).
 *
 * 1막은 카운터에서 이모와 차 한잔, 2막은 이모를 따라 별채로 건너가기, 마무리는 단골 등록입니다.
 * 뼈대와 순서는 여기 데이터로 고정합니다. 모델이 만드는 것은 두 가지뿐입니다.
 *   - 4번 공감 + 꼬리 질문 (이모 바이블)
 *   - 2막 요약 초안 (유저가 한 말로만)
 * 둘 다 실패하면 여기 있는 대체 문안을 씁니다.
 *
 * 문장에 호칭이 들어가는 곳은 함수입니다. 조사는 shared/korean.js 의 withJosa 로 붙입니다
 * (하린이, / 지수,).
 *
 * 장면(step)
 *   tea → name → mood → talk → offer → birth → invite → edit → (worryAsk) → card
 *   invite 칩 셋(시안 03 S0b-6): 한 줄 하고 들어갈게요(→ edit) / 인사만 할게요 / 오늘은 이모랑만요
 *   worryAsk: 올릴 말이 고민 같으면 「고민 카드로 올릴까?」를 한 번 묻습니다(O3, 기본은 그냥 말)
 *   safety : 위기(L2 이상). 대본을 멈추고 별채에 올리지 않습니다. 안전 카드 없이 이모 말풍선 + 109 · 119 버튼,
 *            그날은 카운터에서 이모와 이어 얘기(입력창), 다음 날 다시 오면 멈춘 단계부터(C-020 · 핸드오프 15 5장)
 */
import { withJosa } from '../../shared/korean.js';

// 가입 동의 판은 content/legal/consent_screen.md 「버전」이 정답(서버 services/legal.js, DEV-07r · D97). 옛 골목 고지 판(join-notice-v2)은 없앰

export const WELCOME_NOTICES = [
    '인생상회의 멤버들은 AI가 연기하는 가상 인물이에요.',
    '운세는 재미로 봐 주세요. 큰 결정은 직접 내려요.',
    '내가 직접 말한 것만 기억하고, 나 탭에서 언제든 지울 수 있어요.',
];

// 호칭 10자(DEV-07z · D99). 단골이 쓴 말은 40자까지 받아 이름만 뽑음(server/src/services/callName.js)
export const DISPLAY_NAME_MAX_LENGTH = 10;
export const NAME_INPUT_MAX_LENGTH = 40;
export const TALK_MAX_LENGTH = 200;
export const SUMMARY_MAX_LENGTH = 200;

/** 장부(생일)를 꺼내는 데 필요한 유저 말 수. 기분부터 세고 칩도 셉니다 (SPEC_CHANGE_v1.3 16.1 완화, D53) */
export const SAID_BEFORE_OFFER = 2;
/** 첫 방문 며칠 뒤 카운터(/chat/imo)에서 한 번 더 묻는지 */
export const BIRTH_REASK_AFTER_DAYS = 3;

/**
 * 이 말이 나오면 자유 발화 수를 채우지 않아도 그 흐름에 이어 사주를 제안합니다.
 * 공백을 지운 글에서 찾습니다. '운'은 '운동'·'운전'에도 걸려서 넣지 않고 '운세'·'운이' 로 씁니다.
 */
export const OFFER_KEYWORDS = ['운세', '운이', '사주', '앞날', '답답', '궁합', '올해', '팔자'];

/** 1:1 에서 이모가 사주를 다시 물어도 되는 이야기 (DEV_SPEC 4.1 「운세·궁합·시기 얘기」) */
export const REASK_KEYWORDS = ['운세', '운이', '사주', '궁합', '시기', '타이밍', '올해', '팔자', '언제쯤'];

/** 올릴 말이 고민인지 볼 때, 주제 낱말이 없어도 이런 말투면 고민 글로 봅니다 (DEV_SPEC 4.1 2막) */
export const WORRY_HINT_PATTERN = /(고민|어떡하|어떻게\s*(하|해|말)|어쩌지|해야\s*할까|할까요|될까요|\?)/;

/**
 * 차 (SPEC_CHANGE_v1.3 16.1, 시안 09 · 08 K1 · K2, D53). users.tea 에는 차 키를 둡니다.
 * months 가 없으면 늘 있는 차, 있으면 그달(서울)에만 나오는 계절 차. 모두 카페인 없는 차.
 * 이모의 한 줄은 성격을 가볍게 짚는 농담이고 건강 효능은 말하지 않습니다. 호칭 전이라 「손님」으로 부릅니다
 */
// 차 문안 기본값은 content/scripts/onboarding/tea_lines.json 과 같게(콘텐츠가 원본, 서버는 그 파일을 먼저 읽음, DEV-07x 2 · D96)
export const TEAS = [
    {
        key: 'barley',
        name: '보리차',
        months: null,
        line: '보리차 고르는 사람은 꾸밈이 없는 겨. 물 대신 마시는 걸 고르는 사람이 오래 가더라.',
        politeLine: '보리차 고르는 분은 꾸밈이 없어유. 물 대신 마시는 걸 고르는 분이 오래 가더라고유.',
    },
    {
        key: 'yuja',
        name: '유자차',
        months: null,
        line: '유자차는 겉은 새콤한데 속은 달어. 손님도 그런 편 같구먼.',
        politeLine: '유자차는 겉은 새콤한데 속은 달아유. 손님도 그런 편 같구먼유.',
    },
    {
        key: 'dunggulle',
        name: '둥굴레차',
        months: null,
        line: '둥굴레차는 구수하니 순혀. 남 먼저 챙기는 사람들이 이걸 잘 골라.',
        politeLine: '둥굴레차는 구수하니 순하지유. 남 먼저 챙기는 분들이 이걸 잘 고르셔유.',
    },
    {
        key: 'ssuk',
        name: '쑥차',
        months: [3, 4, 5],
        line: '쑥차 고르는 사람은 옛날 맛을 아는 사람이여.',
        politeLine: '쑥차 고르시는 분은 옛날 맛을 아는 분이여유.',
    },
    {
        key: 'maesil',
        name: '매실차',
        months: [3, 4, 5, 6, 7, 8],
        line: '매실차는 새콤해서 정신이 번쩍 들지. 머리 식히고 싶은 날이구먼.',
        politeLine: '매실차는 새콤해서 정신이 번쩍 들지유. 머리 식히고 싶은 날이구먼유.',
    },
    {
        key: 'omija',
        name: '오미자차',
        months: [6, 7, 8],
        line: '오미자는 다섯 맛이 다 난댜. 속이 복잡한 날엔 이게 당기더라.',
        politeLine: '오미자는 다섯 맛이 다 난대유. 속이 복잡한 날엔 이게 당기더라고유.',
    },
    {
        key: 'gukhwa',
        name: '국화차',
        months: [9, 10, 11],
        line: '국화차는 향이 먼저 와. 섬세한 사람이 이걸 좋아혀.',
        politeLine: '국화차는 향이 먼저 와유. 섬세한 분이 좋아하시더라고유.',
    },
    {
        key: 'daechu',
        name: '대추차',
        months: [9, 10, 11, 12, 1, 2],
        line: '대추차는 뭉근하게 오래 끓여야 맛이 나. 서두르지 않는 사람이 고르는 겨.',
        politeLine: '대추차는 뭉근하게 오래 끓여야 맛이 나유. 서두르지 않는 분이 고르시지유.',
    },
    {
        key: 'saenggang',
        name: '생강차',
        months: [12, 1, 2],
        line: '생강차는 맵싸하니 속이 확 데워지지. 오늘 같은 날엔 이게 제일이여.',
        politeLine: '생강차는 맵싸하니 속이 확 데워지지유. 오늘 같은 날엔 이게 제일이여유.',
    },
    {
        key: 'ssanghwa',
        name: '쌍화차',
        months: [12, 1, 2],
        line: '쌍화차 고르는 사람은 진하게 사는 사람이여.',
        politeLine: '쌍화차 고르시는 분은 진하게 사는 분이여유.',
    },
];
export const ANY_TEA = {
    id: 'any',
    label: '아무거나요',
    line: '아무거나가 제일 어려운 주문이여. 오늘 같은 날에 맞는 걸로 줄게.',
    politeLine: '아무거나가 제일 어려운 주문이여유. 오늘 같은 날에 맞는 걸로 드릴게유.',
};
const SEASON_TEA_MAX = 3;
const TEA_BY_KEY = new Map(TEAS.map((tea) => [tea.key, tea]));
const TEA_BY_NAME = new Map(TEAS.map((tea) => [tea.name, tea]));

function monthOf(dateText) {
    return Number(String(dateText).slice(5, 7));
}

/** 그달 계절 차(표 순서) */
export function seasonTeasOf(dateText) {
    const month = monthOf(dateText);
    return TEAS.filter((tea) => tea.months?.includes(month));
}

/** 「아무거나요」면 그 계절 첫 차 */
export function seasonFirstTeaKey(dateText) {
    return seasonTeasOf(dateText)[0]?.key ?? 'barley';
}

/**
 * 1막 차 칩 6~7개: 늘 있는 3 + 계절 2~3(넘치면 날짜로 골라 고정) + 아무거나요(늘 마지막)
 * @param {string} dateText  'YYYY-MM-DD'(서울)
 */
export function teaChipsFor(dateText) {
    const always = TEAS.filter((tea) => !tea.months);
    let season = seasonTeasOf(dateText);
    if (season.length > SEASON_TEA_MAX) {
        const seed = Number(String(dateText).replace(/-/g, '')) % season.length;
        season = [...season.slice(seed), ...season.slice(0, seed)].slice(0, SEASON_TEA_MAX);
        season.sort((a, b) => TEAS.indexOf(a) - TEAS.indexOf(b));
    }
    return [...always, ...season]
        .map((tea) => ({ id: tea.key, label: tea.name }))
        .concat({ id: 'any', label: ANY_TEA.label });
}

export function isTeaKey(value) {
    return TEA_BY_KEY.has(value);
}

/** users.tea → 보이는 이름. 예전에 이름으로 저장한 값(보리차 · 유자차 · 아무거나)도 그대로 읽습니다 */
export function teaNameOf(value) {
    if (!value) {
        return null;
    }
    if (TEA_BY_KEY.has(value)) {
        return TEA_BY_KEY.get(value).name;
    }
    return value === '아무거나' ? '보리차' : value;
}

/** users.tea → 차 키(예전 이름도) */
export function teaKeyOf(value) {
    if (TEA_BY_KEY.has(value)) {
        return value;
    }
    return TEA_BY_NAME.get(value)?.key ?? 'barley';
}

/** 차를 고른 뒤 이모의 한 줄 */
export function teaLineOf(chipId, speech = 'casual') {
    const tea = chipId === 'any' ? ANY_TEA : TEA_BY_KEY.get(chipId);
    return speech === 'polite' ? tea.politeLine : tea.line;
}

/** 재방문 카운터의 차 칩 (시안 03 R1): 「네, {늘 먹던 차}요」 / 「오늘은 {다른 차}요」. 값은 차 키 */
export function revisitTeaChips(tea, dateText = null) {
    const key = teaKeyOf(tea);
    const pool = dateText ? [...seasonTeasOf(dateText), ...TEAS.filter((item) => !item.months)] : TEAS;
    const other = pool.find((item) => item.key !== key) ?? TEAS[0];
    return [
        { tea: key, label: `네, ${teaNameOf(key)}요` },
        { tea: other.key, label: `오늘은 ${other.name}요` },
    ];
}

/** 1막 꼬리 질문에 답하는 칩 (시안 08 K3). 칩도 유저 말 한 번으로 셉니다. empathy 는 이모가 받는 한 줄(대본) */
export const TALK_CHIPS = [
    { id: 'work', label: '일이요', empathy: '그려, 남의 일 하면서 내 속 끓이는 게 제일 고된 겨.' },
    { id: 'people', label: '사람이요', empathy: '사람 일이 제일 어렵지. 마음 쓰는 만큼 지치는 겨.' },
    { id: 'all', label: '그냥 다요', empathy: '그런 날이 있어. 이것저것 한꺼번에 몰려오는 날.' },
];

export const MOOD_CHIPS = [
    { id: 'soso', label: '그럭저럭요', sentence: '오늘은 그럭저럭 지나갔어요.' },
    { id: 'tired', label: '좀 지쳤어요', sentence: '오늘 좀 지친 하루였어요.' },
    { id: 'good', label: '좋은 일 있었어요', sentence: '오늘 좋은 일이 있었어요.' },
];

/** 장면마다 보여 줄 칩과 입력창. 입력창이 없으면 null */
export const STEP_CONTROLS = {
    // 차 칩은 날마다 달라 대본 상태(teaChips)에서 꺼냅니다(counterEngine.controlsFor)
    tea: { chips: [], input: null },
    name: { chips: [], input: { placeholder: '이름만 적어 주세요 (예: 포포)', maxLength: DISPLAY_NAME_MAX_LENGTH } },
    mood: {
        chips: MOOD_CHIPS.map(({ id, label }) => ({ id, label })),
        input: { placeholder: '직접 적어도 돼요', maxLength: TALK_MAX_LENGTH },
    },
    talk: {
        chips: TALK_CHIPS.map(({ id, label }) => ({ id, label })),
        input: { placeholder: '편하게 적어 보세요', maxLength: TALK_MAX_LENGTH },
    },
    // 장부 카드의 버튼(K4). 화면은 카드 안에 그립니다
    offer: {
        chips: [
            { id: 'accept', label: '적어 주세요' },
            { id: 'decline', label: '다음에요' },
        ],
        input: null,
    },
    // 생일은 하단 시트로 받음. 칩 줄 없음, 시트 닫기 = 다음에요(14 결정 62)
    birth: { chips: [], input: null },
    // 칩 줄 아래 입력창(사용자 2026-10-18). 직접 쓴 말은 갈래를 읽어 별채 · 올릴 말 · 카운터에 남기(inviteIntent)
    invite: {
        chips: [
            { id: 'greet', label: '인사만 할게요' },
            { id: 'decline', label: '오늘은 이모랑만요' },
        ],
        input: { placeholder: '이모한테 하고 싶은 말, 별채에 할 말', maxLength: TALK_MAX_LENGTH },
    },
    edit: { chips: [], input: null },
    worryAsk: {
        chips: [
            { id: 'worryCard', label: '고민 카드로 올릴게요' },
            { id: 'plainLine', label: '그냥 말로 할게요' },
        ],
        input: null,
    },
    card: { chips: [], input: null },
    safety: { chips: [], input: { placeholder: '이모한테 편하게 적어 봐요', maxLength: TALK_MAX_LENGTH } },
};

/** 유저가 고른 칩이 대화에 남는 말 */
export const CHIP_SPEECH = {
    accept: { offer: '적어 주세요' },
    decline: { offer: '다음에요', birth: '다음에요', invite: '오늘은 이모랑만요' },
    greet: '인사만 할게요',
    cancelPost: '인사만 할게요',
    worryCard: '고민 카드로 올릴게요',
    plainLine: '그냥 말로 할게요',
};

export const LINES = {
    greeting: '어서 와유. 춥지? 앉어, 차 한잔 줄게. 뭐 마실래?',
    // 자기소개 자리 ①: 이름만 (08 결정 27)
    askName: '나는 순례여. 다들 이모라 불러. 손님은 뭐라고 부르면 될까?',
    askMood(name) {
        return `${withJosa(name, '이', '')}, 오늘 하루는 어땠어?`;
    },
    // 기분 칩마다 이어지는 꼬리 질문 (대본)
    moodFollowUp: {
        soso: '그럭저럭이 제일 무서운 겨. 요즘 마음에 걸리는 거 하나만 말해 봐.',
        tired: '아이고, 얼굴에 써 있네. 뭐 땜에 그렇게 지쳤어?',
        good: '오메, 좋은 일은 나눠야 두 배여. 뭔 일인디?',
    },
    offerLeadIn: '그랬구먼. 마침 잘 왔네.',
    // 자기소개 자리 ②: 하는 일만, 장부 바로 앞 (08 결정 27)
    intro: '여기서 가게 30년 했어. 토정 선생 책 붙들고 살다 보니 사람 기운 보는 게 일이자 취미가 됐지.',
    // 생일은 장부로 묻습니다 (08 결정 28)
    ledger: '단골 되면 여기 장부에 이름 적어 둬. 생일도 적어 두면 그날 차 한 잔 따로 내주고, 기운도 봐 줄게.',
    // 「적어 주세요」 뒤 한 줄, 그다음 생일 시트(14 결정 61)
    ledgerAccept: '그려, 여기 적어 봐. 시간은 몰라도 괜찮여.',
    offerDeclined: '그려, 생각나면 언제든.',
    // 두 줄 풀이 뒤 다음 날 열 이유 (K6)
    readingTail: '자세한 건 내일 아침 운세에 올려 둘게.',
    rustle: '(가게 뒤쪽에서 웃음소리가 들린다)',
    aside: { memberKey: 'son', text: '이모, 여기 귤 더 있어요?' },
    invite(name) {
        return `뒤 별채에 멤버들 와 있어. 말은 세도 속은 깊어. 같이 건너가 볼래? ${name} 얘기 한 줄 하고 들어가면 한마디씩 할 거여.`;
    },
    inviteDeclined: '그려, 오늘은 둘이 마시자. 별채는 다음에 구경시켜 줄게.',
    // 올릴 말이 고민 같을 때 한 번만 묻습니다 (시안 03 O3)
    worryAsk: '이건 고민이구먼. 고민 카드로 올려 둘까? 그럼 멤버 둘이 스레드에 제대로 답해 줄 거여.',
    // 첫 방문 중 나가기(핸드오프 15 X2 · X3, 결정 65 · 66). 대화엔 남기지 않고 시트 · 골목 화면에만
    exitHold: '벌써 가게? 차 식기 전에 한 모금은 하고 가.',
    exitAlley: '불은 켜 둘게. 또 와.',
    // 다시 온 인사(README 4장, 결정 68). tea 는 차 이름(없으면 null)
    resumeGreeting(tea) {
        return tea ? `왔어? ${tea} 다시 데워 놨어. 아까 하던 얘기 마저 하자.` : '왔어? 아까 하던 얘기 마저 하자.';
    },
    // 멈춘 질문 다시(짧은 판). 없는 단계는 인사만. invite 는 원래 문장 그대로
    resumeAsk: {
        tea: '뭐 마실래?',
        name: '뭐라고 불러 줄까?',
        mood: '오늘 하루는 어땠어?',
        offer: '장부에 생일 적어 둘까?',
        birth: '여기 적어 봐. 시간은 몰라도 괜찮여.',
        edit: '별채에 올릴 말, 마저 다듬어 봐.',
    },
    postedWorry: '고민 카드로 올려 뒀어. 들어가면 둘이 스레드에 적어 놓을 거여.',
    posted: '올려 뒀어. 이따 들어가 봐. 다들 한마디씩 할 거여.',
    postCancelled: '그려, 인사만 혀도 돼. 다들 반가워할 거여.',
    // 초대에 직접 「들어갈게요」(DEV-18 6 ①)
    inviteEnter: '그려, 들어가 봐. 다들 반가워할 거여.',
    // 카운터에 남은 말을 받은 뒤 한 번만 문을 가리킴(DEV-18 6 ③, 같은 날 두 번 넘게 조르지 않음)
    inviteNudge: '얘들 궁금하면 언제든 문 열고 들어가.',
    // 남는 말 대체(생성 실패 때) · 애매할 때 되묻기(④)
    inviteStayFallback: '좋지, 여기 앉아 있어도 되여. 차 한 잔 더 내올껴?',
    inviteUnclearFallback: '응? 별채 들어가 볼 겨, 여기 좀 더 있을 겨?',
    farewell(name, hasBirth) {
        if (hasBirth) {
            return `또 와. 내일 아침엔 ${name} 운세 올려둘게.`;
        }
        return '또 와. 내일 아침에 한 문장 올려둘게.';
    },
    safetyContinue: '그려, 여기 있어. 천천히 얘기혀.',
    // 재방문 카운터(/chat/imo). 마신 차를 기억합니다 (DEV_SPEC 4.1 마무리)
    revisitGreeting(tea) {
        if (tea) {
            return `왔어? 늘 먹던 ${tea}?`;
        }
        return '왔어? 밥은 먹었고? 오늘은 무슨 얘기 하러 왔어.';
    },
    // 재방문 차 칩을 고른 뒤 (시안 03 R1)
    teaServedAgain(tea) {
        return `그려, ${tea} 금방 내올게. 앉아 있어.`;
    },
    // 첫 방문에 「오늘은 이모랑만요」를 골랐으면 다음 방문에 한 번 더 초대합니다
    boardReinvite: '저번엔 둘이만 마셨지. 오늘은 별채에 한 줄 보내 볼텨? 다들 한마디씩 할 거여.',
};

/** 이모가 먼저 사주를 다시 묻는 말 (services/counter/birthAsk.js) */
export const BIRTH_ASK_LINES = {
    chat: '그 얘기 나온 김에, 생일 알려주면 내가 제대로 봐줄 수 있는디. 어뗘?',
    revisit: '저번에 생일은 다음에 알려준다 했지. 오늘은 봐줄까?',
};

/** 4번 공감이 실패했을 때의 대체 문안 (프로토타입 empathy()) */
export const EMPATHY_FALLBACKS = [
    {
        pattern: /회사|팀장|상사|야근|출근|일을|업무/,
        text: '그려, 남의 일 하면서 내 속 끓이는 게 제일 고된 겨. 그건 니 잘못만은 아니여.',
    },
    {
        pattern: /연애|남친|여친|헤어|썸|좋아하/,
        text: '마음 쓰는 일은 원래 사람을 지치게 혀. 그래도 그만큼 진심이란 거여.',
    },
    { pattern: /돈|월세|대출|창업|적금|카드/, text: '돈 걱정은 밤에 더 커지는 법이여. 낮에 숫자로 보면 반으로 줄어.' },
];
export const EMPATHY_DEFAULT = '그랬구먼. 말로 꺼낸 것만으로도 반은 내려놓은 겨.';
export const FOLLOW_UP_FALLBACK = '그랬구먼. 좀 더 얘기해 봐. 뭐가 제일 마음에 걸려?';

/** 요약 초안이 실패하고 유저가 한 말도 없을 때 */
export const SUMMARY_DEFAULT = '오늘 인생상회에 처음 와 봤어요.';

/**
 * 단골 카드의 환영 인사 (시안 06 S0b-8). 사주 유무와 관계없이 같은 문구. 운세 · 니체 · 알림 얘기는 하지 않습니다
 */
export function regularWelcome(name) {
    return `어서 와요, ${name} 님. 오늘부터 인생상회 단골이에요. 언제든 편히 들러요.`;
}

/**
 * 사주를 받은 자리에서 이모가 하는 한두 줄 풀이. 일간 오행으로 고릅니다.
 * 생성하지 않습니다(DEV_SPEC 4.1: 생성은 공감·요약 두 곳뿐). 예언하지 않고 처신만 말합니다.
 */
export const BIRTH_READINGS = {
    wood: '나무 기운이 도는 사람이구먼. 뻗어 나가려는 힘이 좋은디, 오늘처럼 지친 날은 가지치기부터 혀. 다 끌어안지 말고.',
    fire: '불 기운이 도는 사람이네. 마음이 먼저 달아오르니께 오늘은 큰 결정은 하루 묵혀 두고 봐.',
    earth: '흙 기운이 도는 사람이여. 남 받쳐 주느라 제 몫을 놓치기 쉬워. 오늘은 니 밥부터 챙겨.',
    metal: '쇠 기운이 도는 사람이구먼. 맺고 끊는 게 분명혀서 속으로 삭이는 게 많지. 오늘은 한 가지만 내려놔 봐.',
    water: '물 기운이 도는 사람이네. 남 챙기다 제 몫을 놓치기 쉬워. 오늘 지친 건 그 탓도 있으니께 너무 자책 말어.',
};
export const BIRTH_READING_DEFAULT = '고마워, 잘 받아 뒀어. 내일 아침부터 운세 걸 때 같이 볼게.';

// ── 존댓말 판본 (D20) ─────────────────────────────────────────
// 단골이 이모(53세)보다 나이가 많을 때. 나이는 생일로만 알므로, 대본에서는 사주를 받은 뒤의 줄부터 쓰입니다.
// 충청도 존댓말(~여유, ~혀유, ~유 · 「~여요」 꼴 안 씀, DEV-17). 느릿하고 묵직한 말맛은 그대로 두고 문장 끝만 높입니다.

export const POLITE_LINES = {
    ...LINES,
    askName: '나는 순례여유. 다들 이모라 불러유. 손님은 뭐라고 불러 드리면 될까유?',
    intro: '여기서 가게 30년 했어유. 토정 선생 책 붙들고 살다 보니 사람 기운 보는 게 일이자 취미가 됐지유.',
    ledger: '단골 되시면 여기 장부에 이름 적어 두셔유. 생일도 적어 두시면 그날 차 한 잔 따로 내 드리고, 기운도 봐 드릴게유.',
    ledgerAccept: '그려유, 여기 적어 주셔유. 시간은 몰라도 괜찮어유.',
    offerDeclined: '그려유, 생각나시면 언제든유.',
    readingTail: '자세한 건 내일 아침 운세에 올려 둘게유.',
    invite(name) {
        return `뒤 별채에 멤버들 와 있어유. 말은 세도 속은 깊어유. 같이 건너가 보실래유? ${name} 님 얘기 한 줄 하고 들어가시면 한마디씩 할 거여유.`;
    },
    inviteDeclined: '그려유, 오늘은 둘이 마셔유. 별채는 다음에 구경시켜 드릴게유.',
    worryAsk: '이건 고민이구먼유. 고민 카드로 올려 드릴까유? 그럼 멤버 둘이 스레드에 제대로 답해 드릴 거여유.',
    exitHold: '벌써 가셔유? 차 식기 전에 한 모금은 하고 가셔유.',
    exitAlley: '불은 켜 둘게유. 또 오셔유.',
    resumeGreeting(tea) {
        return tea
            ? `오셨어유? ${tea} 다시 데워 놨어유. 아까 하던 얘기 마저 해유.`
            : '오셨어유? 아까 하던 얘기 마저 해유.';
    },
    resumeAsk: {
        tea: '뭐 드실래유?',
        name: '뭐라고 불러 드릴까유?',
        mood: '오늘 하루는 어떠셨어유?',
        offer: '장부에 생일 적어 두실래유?',
        birth: '여기 적어 주셔유. 시간은 몰라도 괜찮어유.',
        edit: '별채에 올릴 말, 마저 다듬어 보셔유.',
    },
    postedWorry: '고민 카드로 올려 뒀어유. 들어가시면 둘이 스레드에 적어 놓을 거여유.',
    posted: '올려 뒀어유. 이따 들어가 보셔유. 다들 한마디씩 할 거여유.',
    postCancelled: '그려유, 인사만 하셔도 돼유. 다들 반가워할 거여유.',
    inviteEnter: '그려유, 들어가 보셔유. 다들 반가워할 거여유.',
    inviteNudge: '별채 궁금하시면 언제든 문 열고 들어가셔유.',
    inviteStayFallback: '좋지유, 여기 앉아 계셔도 돼유. 차 한 잔 더 내올까유?',
    inviteUnclearFallback: '별채 들어가 보실래유, 여기 좀 더 계실래유?',
    farewell(name, hasBirth) {
        if (hasBirth) {
            return `또 오셔유. 내일 아침엔 ${name} 님 운세 올려둘게유.`;
        }
        return '또 오셔유. 내일 아침에 한 문장 올려둘게유.';
    },
    safetyContinue: '그려유, 여기 있어유. 천천히 얘기하셔유.',
    revisitGreeting(tea) {
        if (tea) {
            return `오셨어유? 늘 드시던 ${tea}로 드릴까유?`;
        }
        return '오셨어유? 진지는 드셨고유? 오늘은 무슨 얘기 하러 오셨어유.';
    },
    teaServedAgain(tea) {
        return `그려유, ${tea} 금방 내올게유. 앉아 계셔유.`;
    },
    boardReinvite: '저번엔 둘이만 마셨지유. 오늘은 별채에 한 줄 보내 보실래유? 다들 한마디씩 할 거여유.',
};

export const POLITE_BIRTH_READINGS = {
    wood: '나무 기운이 도는 분이구먼유. 뻗어 나가려는 힘이 좋은디, 오늘처럼 지친 날은 가지치기부터 하셔유. 다 끌어안지 마시고유.',
    fire: '불 기운이 도는 분이네유. 마음이 먼저 달아오르니께 오늘은 큰 결정은 하루 묵혀 두고 보셔유.',
    earth: '흙 기운이 도는 분이여유. 남 받쳐 주느라 제 몫을 놓치기 쉬워유. 오늘은 본인 끼니부터 챙기셔유.',
    metal: '쇠 기운이 도는 분이구먼유. 맺고 끊는 게 분명하셔서 속으로 삭이는 게 많지유. 오늘은 한 가지만 내려놔 보셔유.',
    water: '물 기운이 도는 분이네유. 남 챙기다 제 몫을 놓치기 쉬워유. 오늘 지치신 건 그 탓도 있으니께 너무 자책 마셔유.',
};
export const POLITE_BIRTH_READING_DEFAULT = '고마워유, 잘 받아 뒀어유. 내일 아침부터 운세 올릴 때 같이 볼게유.';

/** 말높이에 맞는 이모 대본 줄 */
export function linesFor(speech) {
    return speech === 'polite' ? POLITE_LINES : LINES;
}

export function birthReadingFor(element, speech) {
    if (speech === 'polite') {
        return POLITE_BIRTH_READINGS[element] ?? POLITE_BIRTH_READING_DEFAULT;
    }
    return BIRTH_READINGS[element] ?? BIRTH_READING_DEFAULT;
}
